export default class BatchSmsCriteria {
    constructor({
      classId,
      teacherId,
    } = {}) {
      this.classId = classId
      this.teacherId = teacherId
    }
  }